import { jwtDecode } from "jwt-decode";
import moment from "moment";
import { initToast } from "../../../network/serverErrorHandler";
import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

type Credentials = {
  username: string;
  password: string;
};

export const validateLogin = ({
  username,
  password,
}: Credentials): string | null => {
  if (!username.trim() || !password.trim()) {
    return "Username and password are required.";
  }
  return null;
};

export const decodeToken = (token: string): any => {
  try {
    let res = jwtDecode(token);

    return res;
  } catch (error) {
    console.log("decodeToken() - error", error);
  }
};

export const validateCredentials = (
  credentials: Credentials
): string | null => {
  if (!credentials.username.trim() || !credentials.password.trim()) {
    return "Username and password are required.";
  }
  return null;
};

export const checkDaysAgo = (date: string) => {
  const givenDate = moment(date);
  const today = moment().startOf("day");

  const diffInDays = today.diff(givenDate, "days");
  if (diffInDays === 0) {
    return checkTimeAgo(date);
  }
  if (diffInDays === 1) {
    return "1 day ago";
  } else if (diffInDays === 2) {
    return "2 days ago";
  } else if (diffInDays === 3) {
    return "3 days ago";
  } else {
    return date;
  }
};

export const checkTimeAgo = (date: string) => {
  const givenDate = moment.utc(date); // Convert date to GMT
  const now = moment.utc(); // Get current GMT time
  const diffInSeconds = now.diff(givenDate, "seconds");

  if (diffInSeconds < 60) {
    return `${diffInSeconds} seconds ago`;
  } else if (diffInSeconds < 3600) {
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    return `${diffInMinutes} minutes ago`;
  } else if (diffInSeconds < 86400) {
    const diffInHours = Math.floor(diffInSeconds / 3600);
    return `${diffInHours} hours ago`;
  } else {
    const diffInDays = Math.floor(diffInSeconds / 86400);
    return `${diffInDays} days ago`;
  }
};

export const validatePayload = (payload: any) => {
  if (!payload.transferType) {
    initToast("Please select a transfer type");
    return false;
  }
  if (!payload.fromAccount) {
    initToast("Please select an account");
    return false;
  }
  if (!payload.toAccount) {
    initToast("Please select a beneficiary");
    return false;
  }
  if (!payload.amount) {
    initToast("Please enter an amount");
    return false;
  }
  if (!payload.narration) {
    initToast("Please enter a narration");
    return false;
  }
  return true;
};

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const getThemeColor = (theme: string) => {
  if (theme === "digibank") return "#DC524C";
  if (theme === "aub") return "#D3940F";
  return "#DC524C";
};
